import CheckCircle from "@mui/icons-material/CheckCircle";
import { Box } from "@mui/material";
import Button from "components/Button";
import ModalLayout from "components/Modal";
import useRedirect from "helpers/hooks/useRedirect";
import { COLORS } from "helpers/utils/constants";
import React from "react";

const AppliedSuccessModal = ({ open, onClose ,t = (d) => d}) => {
  const { navigateJobNetworks } = useRedirect();
  return (
    <ModalLayout open={open} onClose={onClose} light width="min(450px,90%)">
      <Box className="flex-column items-center justify-center px-4 py-4">
        <CheckCircle
          className="mt-6"
          sx={{ color: COLORS.GREEN, fontSize: 100 }}
        />
        <h2 className="mt-4 fw-700 fs-30">{t("Application Sent!")}</h2>
        <p className="c-title fs-15 my-2">
          {t("Congratulations on your application! Good luck!")}
        </p>
        <Button onClick={navigateJobNetworks} classes="transform-none mt-4">
          {t("Back to Job Search")}
        </Button>
      </Box>
    </ModalLayout>
  );
};

export default AppliedSuccessModal;
